import { WorkoutStatCard } from './workout-stat-card'
import { WorkoutStatIcon } from './workout-stat-icon'
import { WorkoutStatTitle } from './workout-stat-title'
import { WorkoutStatValue } from './workout-stat-value'
import { WorkoutStatsSkeleton } from './workout-stats-skeleton'
import React from 'react'
import { PageContainer } from 'src/component/page-container/page-container'
import { useCurrentMonthWorkoutStats } from 'src/hook/use-workout-stats'
import { timeUtil } from 'src/util/time-util'

export const WorkoutStats = (): React.ReactElement => {
  const { data: myCurrentWorkoutStats = [], isLoading, isError } = useCurrentMonthWorkoutStats()

  const currentMonth = timeUtil.dateToMonthYear(new Date())

  if (isLoading) return <WorkoutStatsSkeleton />

  if (!myCurrentWorkoutStats || myCurrentWorkoutStats.length === 0 || isError) return <></>

  const stats = myCurrentWorkoutStats[0]

  return (
    <PageContainer>
      <div className="py-6 md:py-[82px]">
        <h2 className="text-4xl font-medium font-evogria text-primary mb-10">{currentMonth.toUpperCase()}</h2>
        <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 lg:grid-cols-4">
          <WorkoutStatCard>
            <WorkoutStatIcon iconType="dumbbell" />
            <WorkoutStatValue>{stats?.completedWorkoutsCount ?? 0}</WorkoutStatValue>
            <WorkoutStatTitle>Workouts</WorkoutStatTitle>
          </WorkoutStatCard>
          <WorkoutStatCard>
            <WorkoutStatIcon iconType="calories" />
            <WorkoutStatValue>{stats?.totalCalories ?? 0}</WorkoutStatValue>
            <WorkoutStatTitle>Calories</WorkoutStatTitle>
          </WorkoutStatCard>
          <WorkoutStatCard>
            <WorkoutStatIcon iconType="hustle" />
            <WorkoutStatValue>{stats?.totalHustle ?? 0}</WorkoutStatValue>
            <WorkoutStatTitle>Hustle</WorkoutStatTitle>
          </WorkoutStatCard>
          <WorkoutStatCard>
            <WorkoutStatIcon iconType="awards" />
            <WorkoutStatValue>{stats?.awardsCount ?? 0}</WorkoutStatValue>
            <WorkoutStatTitle>Awards</WorkoutStatTitle>
          </WorkoutStatCard>
        </div>
      </div>
    </PageContainer>
  )
}
